import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthConfigIds } from '../../auth/auth.config';

export const authActions = createActionGroup({
  source: 'Auth',
  events: {
    startAuth: emptyProps(),
    attemptLogin: props<{ idp?: AuthConfigIds }>(),
    loginSuccessful: props<{ idp: AuthConfigIds }>(),
    loginFailed: props<{ error: string }>(),
    attemptLogout: props<{ idp?: AuthConfigIds; isMessage?: boolean }>(),
    loggedOut: emptyProps(),
    ongoingAuthCheck: props<{ checking: boolean }>(),
    deleteFactors: emptyProps(),
  },
});
